import { render, staticRenderFns } from "./ProductMultiSelect.vue?vue&type=template&id=59fd08d9&"
import script from "./ProductMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./ProductMultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ProductMultiSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports